<template>
  <div ref="videobox" >
  <videoPlayer  class="video-player-box"
                 ref="videoPlayer"
                 :options="playerOptions"
                 :playsinline="true"
                 @play="onPlayerPlay($event)"
                 @pause="onPlayerPause($event)"
                 @ended="onPlayerEnded($event)"
                 @waiting="onPlayerWaiting($event)"
                 @playing="onPlayerPlaying($event)"
                 @loadeddata="onPlayerLoadeddata($event)"
                 @timeupdate="onPlayerTimeupdate($event)"
                 @canplay="onPlayerCanplay($event)"
                 @canplaythrough="onPlayerCanplaythrough($event)"

                 @statechanged="playerStateChanged($event)"
                 @ready="playerReadied">
  </videoPlayer>
  <div class="loading" v-show="!videoLoaded">
    <div class="loader">
      <div class="center"></div>
      <div class="outer"><span></span><span></span></div>
      <div class="inner"></div>
    </div>
  </div>
  </div>
</template>

<script>
  // require styles
  import 'video.js/dist/video-js.css'

  import { videoPlayer } from 'vue-video-player'
  // Similarly, you can also introduce the plugin resource pack you want to use within the component
  // import 'some-videojs-plugin'
  export default {
    components: {
      videoPlayer,
    },
    props: {
      videosrc: String,
      postersrc: String
    },
    data() {
      return {
        videoLoaded: false,
        isVisible: true,
        play: false,
        playerOptions: {
          // videojs options
          muted: true,
          autoplay: true,
          language: 'en',
          loop: true,
          controls:false,

          sources: [{
            type: "video/mp4",
            src: this.videosrc,
          }],
          poster: this.postersrc,
        }
      }
    },
    mounted() {
      //console.log('this is current player instance object', this.player)
    //  console.log(this.videosrc);
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      visibilityChanged (isVisible, entry) {
        this.isVisible = isVisible
     /*   console.log( this.videosrc + '-' +isVisible);
        let p= this.$refs.videoPlayer.player;
        if(isVisible===false) {
         p.play(false);
          this.play = false;
        }
        else {
          if(this.play !=true) {
         p.play(true);
            this.play = true;
          }
        }*/
      },
      // listen event
      onPlayerPlay(player) {
        // console.log('player play!', player)
      },
      onPlayerPause(player) {
        // console.log('player pause!', player)
      },
      // ...player event

      // or listen state event
      playerStateChanged(playerCurrentState) {
       // console.log('player current update state', playerCurrentState)
      },

      // player is ready
      playerReadied(player) {
        //console.log('the player is readied', player)
        // you can use it to do something...
        // player.[methods]
      },
      onPlayerLoadeddata(player) {

      },
      onPlayerCanplay(player) {

      },
      onPlayerCanplaythrough(player) {

      },
      onPlayerTimeupdate(player) {

      },
      onPlayerPlaying(player) {
        this.videoLoaded = true;
      },
      onPlayerWaiting(player) {

      },
    }
  }
</script>
